import React from 'react';
import ReactDOM from 'react-dom';

import { Route, Link } from 'react-router-dom';

import { avangaEncodeURI } from './../helpers';

// 3rd Party
import Collapse from 'react-collapse';

class MovieFull extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      index: props.index,
      isMobile: props.isMobile,
      items: props.items,
      itemsPerRow: 3,
      total: props.items.length
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      index: nextProps.index,
      isMobile: nextProps.isMobile,
      items: nextProps.items,
      total: nextProps.items.length
    });
  }

  render() {
    if (this.state.isMobile) {
      return (
        <section key={window.location.pathname} className="movie-full mobile-item">
          <Route path={`/video/${avangaEncodeURI(this.state.items[this.state.index].title)}`} children={({ match }) => (
            <div className="movie-item">
              <Collapse className={match ? 'open-item' : ''} isOpened={match}>
                <div>
                  <Link to={'/'} className="close-video">
                    <svg id="Ebene_1" xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 100 100">
                      <g>
                        <path fill="#8e8e8e" d="M50,5A45,45,0,1,0,95,50,45,45,0,0,0,50,5ZM77,54.75H54.75V77a4.76,4.76,0,1,1-9.5,0V54.75H23a4.76,4.76,0,1,1,0-9.5H45.25V23a4.76,4.76,0,1,1,9.5,0V45.25H77a4.76,4.76,0,1,1,0,9.5Z"/>
                      </g>
                    </svg>
                  </Link>
                  <h1>{this.state.items[this.state.index].title}</h1>
                  <h2>{this.state.items[this.state.index].subline}</h2>
                  {match &&
                    <div>
                      <div className="embed-container">
                        <iFrame frameBorder="0" width="100%" height="100%" src={`${this.state.items[this.state.index].vimeo_video}?title=0&byline=0&portrait=0`} webkitAllowFullScreen mozAllowFullScreen allowFullScreen />
                      </div>
                    </div>
                  }
                </div>
              </Collapse>
            </div>
          )}/>
        </section>
      );
    }

    if ((this.state.index + 1) % this.state.itemsPerRow === 0) {
      return (
        <section key={window.location.pathname} className="movie-full desktop-item">
          {this.state.items.map((item, index) => {
            if ((index <= this.state.index) && (index >= (this.state.index - 2))) {
              return (
                <Route path={`/video/${avangaEncodeURI(item.title)}`} children={({ match }) => (
                  <Collapse className={match ? 'open-item' : ''} isOpened={match}>
                    <div className="movie-item">
                      <Link to={'/'} className="close-video">
                        <svg id="Ebene_1" xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 100 100">
                          <g>
                            <path fill="#8e8e8e" d="M50,5A45,45,0,1,0,95,50,45,45,0,0,0,50,5ZM77,54.75H54.75V77a4.76,4.76,0,1,1-9.5,0V54.75H23a4.76,4.76,0,1,1,0-9.5H45.25V23a4.76,4.76,0,1,1,9.5,0V45.25H77a4.76,4.76,0,1,1,0,9.5Z"/>
                          </g>
                        </svg>
                      </Link>
                      <h1>{item.title}</h1>
                      <h2>{item.subline}</h2>
                      {match &&
                      <div>
                        <div className="embed-container">
                          <iFrame frameBorder="0" width="100%" height="100%" src={`${item.vimeo_video}?title=0&byline=0&portrait=0`} webkitAllowFullScreen mozAllowFullScreen allowFullScreen />
                        </div>
                      </div>
                      }
                    </div>
                  </Collapse>
                )}/>
              );
            }
          })}
        </section>
      );
    }

    if (this.state.total % this.state.itemsPerRow !== 0 && (this.state.index + 1) === this.state.total) {
      return (
        <article key={window.location.pathname} className="movie-full desktop-item">
          {this.state.items.map((item, index) => {
            if (index >= (this.state.index - 1)) {
              return (
                <Route path={`/video/${avangaEncodeURI(item.title)}`} children={({ match }) => (
                  <div className="movie-item">
                    <Collapse isOpened={match}>
                      <div>
                        <Link to={'/'} className="close-video">
                          <svg id="Ebene_1" xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 100 100">
                            <g>
                              <path fill="#8e8e8e" d="M50,5A45,45,0,1,0,95,50,45,45,0,0,0,50,5ZM77,54.75H54.75V77a4.76,4.76,0,1,1-9.5,0V54.75H23a4.76,4.76,0,1,1,0-9.5H45.25V23a4.76,4.76,0,1,1,9.5,0V45.25H77a4.76,4.76,0,1,1,0,9.5Z"/>
                            </g>
                          </svg>
                        </Link>
                        <h1>{item.title}</h1>
                        <h2>{item.subline}</h2>
                        {match &&
                        <div>
                          <div className="embed-container">
                            <iFrame frameBorder="0" width="100%" height="100%" src={`${item.vimeo_video}?title=0&byline=0&portrait=0`} webkitAllowFullScreen mozAllowFullScreen allowFullScreen />
                          </div>
                         </div>
                        }
                      </div>
                    </Collapse>
                  </div>
                )}/>
              );
            }
          })}
        </article>
      );
    }

    return false;
  }
}

export default MovieFull;


// WEBPACK FOOTER //
// ./src/sections/movies/movie-full.jsx